export default {
  cancel: 'Cancel',
  reply: 'Reply',
  onMyWay: 'On my way',
  customMessage: 'Custom Message',
  callMeBackIn: 'Call me back in',
  willCallYouBackIn: 'Will call you back in',
  min: 'min',
  hours: 'hours',
  days: 'days',
} as const;
